import {GET_CARS, GET_CARS_SUCCESS, UPDATE_CARS_PAGINATION} from "../constants/Cars";

export const getCars = (page, perPage = 10, search = "") => {
  return {
    type: GET_CARS,
    perPage,
    search,
    page
  }
}

export const getCarsSuccess = (cars, total, from, to) => {
  return {
    type: GET_CARS_SUCCESS,
    cars,
    from,
    to,
    total
  }
}

export const updateCarsPagination = (page, perPage = 10, search = "") => {
  return {
    type: UPDATE_CARS_PAGINATION,
    perPage,
    search,
    page
  }
}